import { styled, Theme, TableCell, Select, Toolbar } from '@mui/material';
import { brightpathTheme } from '@youscience/theme';

export const sxStyles = {
  paper: {
    borderRadius: '12px',
  },
  headRow: {
    height: '40px',
  },
  searchWrap: (theme: Theme) => ({
    maxWidth: '220px',

    '& > div:first-of-type': {
      '& .MuiInputBase-root': {
        borderRadius: '4px',
        border: `1px solid ${theme.palette.grey['300']}`,
        backgroundColor: '#F9F9F9',
      },
    },
  }),
  tableBodyRow: (theme: Theme) => ({
    borderTop: `1px solid ${theme.palette.grey['300']}`,
    height: '52px',

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#EBF6F7',
    },
  }),
  deadlineWrap: {
    display: 'flex',
    alignItems: 'center',

    '& > div:first-of-type': {
      display: 'flex',
      marginLeft: '0.75rem',
    },
  },
  showMore: {
    fontSize: '0.813rem',
    textDecoration: 'underline',
    color: brightpathTheme.palette.secondary.main,
  },
  flexAlignPosition: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '0 !important',

  [theme.breakpoints.down('sm')]: {
    gap: '1rem',
    flexDirection: 'column',
    justifyContent: 'start',
  },
}));

export const StyledTotalStudents = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: '1rem',
  padding: '0.225rem 0.75rem',
  border: `1px solid ${theme.palette.grey['600']}`,
  backgroundColor: theme.palette.grey['100'],
  borderRadius: '8px',
  fontSize: '0.813rem',
}));

export const StyledActionsRequiredCell = styled(TableCell)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '0.5rem',
  minWidth: '224px',
  maxWidth: '620px',
  minHeight: '51px',
}));

export const StyledFilterSelect = styled(Select)(({ theme }) => ({
  color: brightpathTheme.palette.secondary.main,
  marginLeft: '0.5rem',

  '.MuiOutlinedInput-input': {
    fontSize: '0.875rem',
    padding: '0.5rem 1rem',
    marginRight: '0.35rem',
  },

  '.MuiOutlinedInput-notchedOutline': {
    borderRadius: '40px',
    border: `1px solid ${brightpathTheme.palette.secondary.main}`,
    borderColor: `${brightpathTheme.palette.secondary.main} !important`,
  },

  '& > svg:first-of-type': {
    color: brightpathTheme.palette.secondary.main,
  },

  '&:hover': {
    '.MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${brightpathTheme.palette.secondary.dark}`,
    },
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));
